import ProductDetailPage from './ProductDetailPage.jsx';

export {
  ProductDetailPage
}


// WEBPACK FOOTER //
// ./pages/product-detail/index.js